export default function (_this)
{
  const i18nHead = _this.$nuxtI18nHead({ addSeoAttributes: true });
  return {
    meta: i18nHead.meta,
    link: i18nHead.link,
  };
}
